<template>
  <div class="search-results">
    <h1>
      Search Results for "{{ term }}"
      <span class="icon-container" v-if="isLoading">
        <i class="fal fa-sun fa-spin fa-fw text-red" />
      </span>
    </h1>
    <bdg-table-view :rows="allSearchResults" :columns="columns" />
  </div>
</template>

<script>
import BdgTableView from "../elements/table-view/BdgTableView";
import LinkCell from "../elements/table-view/special-cells/LinkCell";
import ContactForm from "../forms/ContactForm";

export default {
  name: "SearchResults",
  components: { BdgTableView },
  props: {
    term: String
  },
  data() {
    return {
      columns: [
        { label: "", property: "linkInfo", cellComponent: LinkCell },
        { label: "", property: "entityName" }
      ]
    };
  },
  computed: {
    isSearchingContacts() {
      return this.$store.state.Search.isSearchingContacts;
    },
    isSearchingContracts() {
      return this.$store.state.Search.isSearchingContracts;
    },
    isSearchingProjects() {
      return this.$store.state.Search.isSearchingProjects;
    },
    isLoading() {
      return (
        this.isSearchingContacts ||
        this.isSearchingContracts ||
        this.isSearchingProjects
      );
    },
    contacts() {
      const contacts = this.$store.state.Search.searchedContacts;
      if (contacts) {
        const component = this;
        return contacts.map(c => {
          c.entityName = "Contact";
          c.linkInfo = {
            text: c.name,
            clickAction() {
              component.contactClick(c);
            }
          };
          return c;
        });
      }
      return [];
    },
    contracts() {
      const contracts = this.$store.state.Search.searchedContracts;
      if (contracts) {
        const component = this;
        return contracts.map(c => {
          c.entityName = "Contract";
          c.linkInfo = {
            text: c.name,
            clickAction() {
              component.contractClick(c);
            }
          };
          return c;
        });
      }
      return [];
    },
    projects() {
      const projects = this.$store.state.Search.searchedProjects;
      if (projects) {
        const component = this;
        return projects.map(p => {
          p.entityName = "Project";
          p.linkInfo = {
            text: p.name,
            clickAction() {
              component.projectClick(p);
            }
          };
          return p;
        });
      }
      return [];
    },
    allSearchResults() {
      return [...this.contacts, ...this.contracts, ...this.projects];
    }
  },
  watch: {
    term(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search();
      }
    }
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      if (this.term) {
        this.$store.dispatch("globalSearch", this.term);
      }
    },
    contactClick(contact) {
      this.$router.push({ name: "contacts" }).then(() => {
        this.$store.commit("setCreateEditComponentParams", {
          createEditComponent: ContactForm,
          createEditComponentData: contact,
          createEditComponentIsShown: true
        });
      });
    },
    contractClick(contract) {
      this.$router.push({
        name: "contracts-show",
        params: { id: contract.id }
      });
    },
    projectClick(project) {
      this.$router.push({
        name: "projects-show",
        params: { id: project.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-results {
  @apply py-6;

  @screen md {
    @apply px-12 py-16;
  }

  & > h1 {
    @apply mb-5 ml-4 uppercase;

    @screen md {
      @apply ml-0;
    }
  }
}
</style>
